import _groupBy from 'lodash/groupBy'
import _orderBy from 'lodash/orderBy'
import _range from 'lodash/range'
import moment from 'moment'

import { BaseView } from '../../../shared/utils/baseComponent'
import css from './orders.styles.scss'
import template from './orders.template.pug'

export class TasksiteOrdersController extends BaseView {
  constructor($state, $mdDialog, $mdMedia, $element, OrderFactory) {
    'ngInject'
    super($element)
    Object.assign(
      this,
      { $state, $mdDialog, $mdMedia, OrderFactory },
      {
        statusOrder: ['NEW', 'ACCEPTED', 'DISPATCHED', 'DONE', 'RELEASED'],
        yearRange: _range(new Date().getFullYear(), new Date().getFullYear() - 3),
      },
    )
    this.eyeCatcher = require('../../assets/orders.svg')
  }

  $onChanges(changes) {
    if (changes.orders) {
      this.orders.forEach((order) => {
        if (order.creator)
          order.creatorFull = `${order.creator.firstName} ${order.creator.lastName} ${order.creator.email}`
      })
      this.orders = _orderBy(this.orders, ['taskDate'], ['desc'])
      this.groupOrders()
    }
  }

  goto(year) {
    this.$state.go(this.$state.current, { year: year })
  }

  isCurrentYear() {
    return parseInt(this.$state.params.year) === new Date().getFullYear()
  }

  groupOrders() {
    this.groupedOrders = _groupBy(this.orders, 'status')
  }

  reloadOrders() {
    const from = moment().subtract(24, 'months').format('YYYY-MM-DD')
    return this.customer.getTasksiteOrders(this.tasksite.code, { from }).then((orders) => {
      this.orders = orders
      return this.orders
    })
  }

  orderCancelled(order) {
    if (order.source === 'TASKSITE') {
      this.customer.removeTasksite(order.taskSiteCode)
      this.$state.go('customers.customer.tasksites', {}, { reload: true })
    } else {
      this.reloadOrders().then(() => this.groupOrders())
    }
  }

  openOrderDialog() {
    const orderCreateDialog = this.$mdDialog.orderCreateDialog({
      fullscreen: true,
      resolve: {
        order: (OrderFactory) => {
          'ngInject'
          const order = new OrderFactory({ customer: this.customer })
          return order.init()
        },
      },
      locals: {
        tasksite: this.tasksite,
      },
    })
    this.$mdDialog.show(orderCreateDialog).then(() => {
      return this.reloadOrders().then(() => this.groupOrders())
    })
  }

  search() {
    const searchDialog = this.$mdDialog.orderSearchDialog({
      fullscreen: true,
      bindToController: true,
      locals: {
        orders: this.orders,
        customer: this.customer,
      },
    })
    return this.$mdDialog.show(searchDialog)
  }

  showStock() {
    const containerStockDialog = this.$mdDialog.containerStockDialog({
      fullscreen: false,
      locals: {
        tasksite: this.tasksite,
        customer: this.customer,
      },
    })
    this.$mdDialog.show(containerStockDialog)
  }
}

export const tasksiteOrdersComponent = {
  controller: TasksiteOrdersController,
  bindings: {
    tasksite: '<',
    tasksites: '<',
    customer: '<',
    orders: '<',
  },
  template: template({ css }),
}



// WEBPACK FOOTER //
// ./app/orders/containers/orders/orders.component.js